<template>
  <div class="home">
    <v-container grid-list-xs fill-height fluid>
      <v-row class="mt-2" align="center" justify="center" no-gutters>
        <v-col>
          <v-card elevation="1" outlined>
            <v-card-title>Device Status</v-card-title>
            <v-card-subtitle>ID : 123456789</v-card-subtitle>
            <v-card class="mx-5 mb-5" dark color="success" outlined>
              <v-row class="mt-2" align="center" justify="center">
                <v-icon>mdi-checkbox-marked-circle</v-icon>
              </v-row>
              <v-row class="mb-2" align="center" justify="center">
                ACTIVE
              </v-row>
            </v-card>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="mt-2" align="center" justify="center" no-gutters>
        <v-col>
          <v-card elevation="1" outlined>
            <v-card-title>Last Events</v-card-title>
              <v-data-table :headers="headers" :items="events" :items-per-page="5" class="elevation-1">
              </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>

export default {
  name: 'home',
  components: {
  },
  data: () => ({
    headers: [
      {
        text: 'Event',
        align: 'left',
        sortable: false,
        value: 'name'
      },
      { text: 'Date', value: 'date' },
      { text: 'Time', value: 'time' },
      { text: 'Action', value: 'action', sortable: false }
    ],
    events: [
      {
        name: 'Falling',
        date: '13/01/2019',
        time: '8:50',
        action: 'Send message'
      },
      {
        name: 'Dog',
        date: '12/01/2019',
        time: '16:32',
        action: 'Nothing'
      }
    ]
  })
};
</script>
